<template>
    <horizontal-stepper
    locale="fr"
    :top-buttons="true"
    :steps="steps"
    @completed-step="completedStep"
    @active-step="isStepActive"
    />
</template>

<script>
    import HorizontalStepper from 'vue-stepper';

    import DomiciliationAddress from '../../vues/domiciliation/DomiciliationAddress.vue';
    import DomiciliationParticulars from './DomiciliationParticulars.vue';
    import Mail from './Mail.vue';
    import DomiciliationOptions from './DomiciliationOptions.vue';
    import DomiciliationPayment from './DomiciliationPayment.vue';

    export default {
        components: {
            HorizontalStepper
        },
        data(){
            return {
                steps: [
                    {
                        icon: 'business',
                        name: 'society',
                        title: 'Adresse',
                        component: DomiciliationAddress,
                        completed: false,
                        alreadyCompleted: false
                    },
                    {
                        icon: 'contacts',
                        name: 'particulars',
                        title: 'Coordonées',
                        component: DomiciliationParticulars,
                        completed: false,
                        alreadyCompleted: false
                    },
                    {
                        icon: 'mail_outline',
                        name: 'mail',
                        title: 'Courrier',
                        component: Mail,
                        completed: false,
                        alreadyCompleted: true
                    },
                    {
                        icon: 'add',
                        name: 'options',
                        title: 'Options',
                        component: DomiciliationOptions,
                        completed: false,
                        alreadyCompleted: true
                    },
                    {
                        icon: 'payment',
                        name: 'payment',
                        title: 'Paiement',
                        component: DomiciliationPayment,
                        completed: false,
                        alreadyCompleted: false
                    }
                ]
            }
        },
        methods: {
            completedStep(payload) {
                this.steps.forEach((step) => {
                    if (step.name === payload.name) {
                        step.completed = true;
                    }
                })
            },
            isStepActive(payload) {
                this.steps.forEach((step) => {
                    if (step.name === payload.name) {
                        if(step.completed === true) {
                            step.completed = false;
                        }
                    }
                })
            }
        }
    }
</script>
